import React, { useState } from "react";
import { Link } from "react-router-dom";
import { postForm } from "../utils/formApi";

const endpoint = process.env.REACT_APP_NEWSLETTER_API_URL;
const enabled = process.env.REACT_APP_NEWSLETTER_ENABLED === "true" && Boolean(endpoint);

export default function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [status, setStatus] = useState("idle");

  async function handleSubmit(event) {
    event.preventDefault();
    if (!enabled || !consent || !email) return;

    setStatus("sending");
    try {
      await postForm(endpoint, {
        email: email.trim(),
        consent: true,
        source: "agroadvisor-website-footer",
        submittedAt: new Date().toISOString(),
      });
      setEmail("");
      setConsent(false);
      setStatus("success");
    } catch (error) {
      console.error("Newsletter signup failed", error);
      setStatus("error");
    }
  }

  return (
    <div className="newsletter-card">
      <div>
        <span className="footer-kicker">Agroadvisor newsletter</span>
        <strong>Updates from Agroadvisor</strong>
        <p>Occasional updates about our projects, research, deployments and applied agricultural technology. The mailing list is not active yet.</p>
      </div>
      <form className="newsletter-form" onSubmit={handleSubmit}>
        <div className="newsletter-row">
          <label className="sr-only" htmlFor="newsletter-email">Email address</label>
          <input
            id="newsletter-email"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            placeholder="you@company.com"
            autoComplete="email"
            disabled={!enabled || status === "sending"}
            required
          />
          <button type="submit" disabled={!enabled || !consent || status === "sending"}>
            {enabled ? (status === "sending" ? "Sending…" : "Subscribe") : "Coming soon"}
          </button>
        </div>
        <label className="consent-line">
          <input
            type="checkbox"
            checked={consent}
            onChange={(event) => setConsent(event.target.checked)}
            disabled={!enabled || status === "sending"}
          />
          <span>I agree to receive the Agroadvisor newsletter and have read the <Link to="/privacy">privacy notice</Link>.</span>
        </label>
        {!enabled && <small className="form-note">Subscription is disabled until the AWS mailing endpoint is connected. No email address is collected.</small>}
        {status === "success" && <small className="form-note form-success">Please check your inbox if confirmation is required.</small>}
        {status === "error" && <small className="form-note form-error">We could not submit the request. Please try again later.</small>}
      </form>
    </div>
  );
}
